export enum ModalType {
  Delete,
  Add
}